export const COMMENTS_FETCH_REQUEST = 'COMMENTS_FETCH_REQUEST';
export const COMMENTS_FETCH_FAILURE = 'COMMENTS_FETCH_FAILURE';
export const COMMENTS_FETCH_SUCCESS = 'COMMENTS_FETCH_SUCCESS';